<template>
  <el-form label-width="130px">
    <el-row>
      <!-- <el-col :span="8">
        <el-form-item label="会员总积分">
          <el-input v-model="detailsData.totalIntegral" readonly></el-input>
        </el-form-item>
      </el-col> -->
      <!-- <el-col :span="8">
        <el-form-item label="会员兑换积分">
          <el-input v-model="detailsData.redeemedIntegral" readonly></el-input>
        </el-form-item>
      </el-col> -->
      <el-col :span="8">
        <el-form-item label="剩余积分">
          <el-input v-model="detailsData.theRestIntegral" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="扫码开瓶数">
          <el-input v-model="detailsData.openNumber" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="最多开瓶系列">
          <el-input v-model="detailsData.openProductName" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="签到天数">
          <el-input v-model="detailsData.signInDays" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="连续签到最长天数">
          <el-input v-model="detailsData.continuousSignInDays" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="拉新人数">
          <el-input v-model="detailsData.acquireNewCustomersNumber" readonly></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="form-title">积分获取记录</div>
        <RecordPointsAcquisition :value="detailsData" />
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="form-title">兑换记录</div>
        <ExchangeRecord :value="detailsData" />
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import RecordPointsAcquisition from './record_points_acquisition';
import ExchangeRecord from './exchange_record';

export default {
  props: {
    value: {
      type: Object,
      default() {
        return {
        };
      },
    },
  },
  components: {
    RecordPointsAcquisition,
    ExchangeRecord,
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          const row = JSON.parse(JSON.stringify(val));
          this.detailsData = row;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      detailsData: {},
    };
  },
};
</script>
<style lang="less" scoped>
.form-title {
  font-size: 16px;
  height: 20px;
  line-height: 20px;
  font-weight: 600;
  margin-bottom: 10px;
}
</style>
